import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#CE1126", width: 30, height: 18 }), /* @__PURE__ */ React.createElement("polygon", { fill: "#FFF", points: "0,0 20.824734,18 30,18 9.175266,0" }), /* @__PURE__ */ React.createElement("polygon", { points: "1.52921,0 22.353945,18 28.470789,18 7.646055,0" }));
const ForwardRef = forwardRef(SvgTt);
const Memo = memo(ForwardRef);
export default Memo;
